import { render, staticRenderFns } from "./businessGuide.vue?vue&type=template&id=53ddc48d&"
import script from "./businessGuide.vue?vue&type=script&lang=js&"
export * from "./businessGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports